import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=41d50718&scoped=true&lang=html&"
import script from "./IconButton.vue?vue&type=script&lang=js&"
export * from "./IconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d50718",
  null
  
)

export default component.exports